import * as React from 'react';
import moving1 from '../../../assets/img/body-1.jpg';
import moving2 from '../../../assets/img/body-2.jpg';
import moving3 from '../../../assets/img/body-3.jpg';
import moving4 from '../../../assets/img/body-4.jpg';

export interface IBody {}

export default function BodyOne(props: IBody) {
  const images = [moving1, moving2, moving3, moving4];
  const text = [
    'FURNITURE DELIVERY',
    'HOME MOVING',
    'OFFICE MOVING',
    'FRAGILES DELIVERY',
  ];

  return (
    <>
      <div className='mt-10 text-center bb-line text-3xl font-medium'>
        MOVING & LOCAL DELIVERY SERVICES
      </div>
      <div className='mt-10  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4    justify-center lg:justify-between w-full '>
        {images.map((image, index) => {
          return (
            <>
              <div key={index} className=' flex-col flex  justify-center '>
                <div className='flex justify-center'>
                  <img src={image} alt='' className='bo-img   ' />
                </div>
                <div className='flex justify-center  py-3 text-2xl w-full '>
                  <div className=' text-center text-white bg-fr w-4/5'>
                    {text[index]}
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
}
